import { useEffect, useState } from "react";
import { StepperComponent } from "./StepperComponent";
import { useRouter } from "next/router";
import JointBidderForm from "./JointBidderFormV2";
import JBDetailsModal from "./JBDetailsModal";
import BankerPageNotFound from "../../BankerPageNotFound";

interface JBFormWrapperProps {
  mode?: string;
  showJBListModal?: boolean;
  setShowJBListModal?: React.Dispatch<React.SetStateAction<boolean>>;
}

export type JBFormMode =
  | "joint-creation"
  | "joint-viewer"
  | "joint-edit"
  | "view"
  | "create"
  | "edit";

export const JBFormWrapper = ({
  mode,
  showJBListModal = false,
  setShowJBListModal = () => {},
}: JBFormWrapperProps) => {
  const [activeStep, setActiveStep] = useState(0);
  const [allBiddersData, setAllBiddersData] = useState<any>();
  const [notFound, setNotFound] = useState(false);
  const router = useRouter();

  const { bidders_count, id } = router.query;

  useEffect(() => {
    if (bidders_count) {
      const biddersArray = Array.from(
        { length: Number(bidders_count) },
        () => ({
          name: "",
          address: "",
          email: "",
          pan: "",
          aadhar_number: "",
          mobile_number: "",
          user_type: { label: "Individual", value: "individual" },
          agreement_signed: false,
          application_form_filled: false,
          kyc_verified: false,
          emd_amount_paid: false,
          initial_bid_price: "",
          initial_bid_price_confirmed: false,
        }),
      );
      setAllBiddersData(biddersArray);
    }
  }, [bidders_count]);

  return (
    <>
      {mode === "create" ? (
        <div className="lg:flex mt-5">
          <StepperComponent
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            totalSteps={Number(bidders_count) ? Number(bidders_count) + 1 : 0}
          />
          <JointBidderForm
            setActiveStep={setActiveStep}
            activeStep={activeStep}
            allBiddersData={allBiddersData}
            currentBidderData={allBiddersData ? allBiddersData[activeStep] : []}
            setCurrentBidderData={setAllBiddersData}
            mode={"joint-creation"}
            totalSteps={Number(bidders_count) ? Number(bidders_count) + 1 : 0}
            bidderFormWrapperClassName="lg:px-9 lg:py-[41px]  space-y-8 lg:space-y-7 w-full lg:bg-brand-bgLightGrey"
          />
        </div>
      ) : mode === "view" && id ? (
        notFound ? (
          <BankerPageNotFound />
        ) : (
          <>
            <JointBidderForm
              mode={"joint-viewer"}
              onNotFound={() => setNotFound(true)}
              bidderFormWrapperClassName="lg:px-9 lg:py-[41px] mt-5  space-y-8 lg:space-y-7 w-full lg:bg-brand-bgLightGrey"
            />
            <JBDetailsModal
              id={id}
              open={showJBListModal}
              onClose={() => setShowJBListModal(false)}
            />
          </>
        )
      ) : mode === "edit" && id ? (
        notFound ? (
          <BankerPageNotFound />
        ) : (
          <>
            <JointBidderForm
              mode={"joint-edit"}
              onNotFound={() => setNotFound(true)}
              bidderFormWrapperClassName="lg:px-9 lg:py-[41px] mt-5  space-y-8 lg:space-y-7 w-full lg:bg-brand-bgLightGrey"
            />
            <JBDetailsModal
              id={id}
              open={showJBListModal}
              onClose={() => setShowJBListModal(false)}
            />
          </>
        )
      ) : (
        <></>
      )}
    </>
  );
};
